var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["text-" + _vm.field.alignment] }, [
    _c(
      "button",
      {
        staticClass: "submit-btn",
        class: [_vm.btnSize],
        style: _vm.btnStyles,
        attrs: { type: "type" }
      },
      [_vm._v(" \n        " + _vm._s(_vm.field.button_text) + " \n    ")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }